import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

export default function Complayananfoto({ onUpdateTotal, tanggal, jammulai }) {
    const urlapi = process.env.REACT_APP_BASE_URL
    const { kode_booking, kode_booking2 } = useParams();
    const [foto, setFoto] = useState([]);
    const [show, setShow] = useState(false);
    const [valfoto, setValfoto] = useState('')
    const [jml, setJml] = useState(0);
    const [dataBookingFoto, setDataBookingFoto] = useState([])
    const [selectedLayanan, setSelectedLayanan] = useState([]);
    const [bookfoto, setBookfoto] = useState('');

    const getfoto = async () => {
        try {
            const response = await axios.get(urlapi + "Fotografer");
            setFoto(response.data);
            // console.log(response.data);
        } catch (error) { }
    };

    const formatrupiah = (numb) => {
        const format = numb.toString().split("").reverse().join("");
        const convert = format.match(/\d{1,3}/g);
        const rupiah = "Rp " + convert.join(".").split("").reverse().join("");
        return rupiah;
    };

    const handlefoto = (e, idfoto, hargafoto) => {

        let allData = JSON.parse(localStorage.getItem('bookingData')) || [];

        if (e.target.checked) {
            // Tambah langsung meskipun idfoto sama sudah ada
            setValfoto(idfoto)
            allData.push({
                idfoto: idfoto.toString(),
                harga: hargafoto.toString()
            });
        } else {
            // Hapus SATU data yang cocok (hanya satu kali)
            setValfoto('');
            const index = allData.findIndex(
                item => item.idfoto === idfoto.toString() && item.harga === hargafoto.toString()
            );
            if (index !== -1) {
                allData.splice(index, 1);
            }
        }

        localStorage.setItem('bookingData', JSON.stringify(allData));

        const data = JSON.parse(localStorage.getItem('bookingData')) || [];
        let total = data.reduce((sum, item) => {
            return sum + parseInt(item.harga);
        }, 0);

        console.log("Total Harga:", total);
        localStorage.setItem("totalHarga", total);

        onUpdateTotal(valfoto);
    }

    const getBookingFoto = async () => {
        try {
            const response = await axios.get(urlapi + "BookingFoto?kode=" + kode_booking + "&&kode2=" + kode_booking2 + "&&iduser=" + localStorage.getItem('id'));
            console.log(response.data);
            setDataBookingFoto(response.data);

        } catch (error) {
            console.log(error.message);

        }
    }


    const cekfoto = async (tgl, jm) => {
        try {
            const response = await axios.get(urlapi + "Cekbookfoto?tgl=" + tgl + "&&jammulai=" + jm)
            console.log(response.data);
            setBookfoto(response.data);

        } catch (error) {
            console.log(error.message);

        }
    }

    const Handlehapusfoto = async (kode_booking, idfoto) => {
        Swal.fire({
            title: 'Apakah kamu yakin?',
            text: "Data yang dihapus tidak bisa dikembalikan!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, hapus!',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {

                hapusFoto(kode_booking, idfoto)
            }
        });
    }

    const hapusFoto = async (kode, idfoto) => {
        await axios.put(urlapi + "Layanan/" + kode + '/' + idfoto + '/foto')
            .then((response) => {
                console.log(response);
                getfoto();
                getBookingFoto();
                Swal.fire(
                    'Terhapus!',
                    'Data berhasil dihapus.',
                    'success'
                );
            }).catch((err) => {

            });
    }

    useEffect(() => {
        getfoto();
        getBookingFoto();
        cekfoto(tanggal, jammulai)
    }, [])

    return (
        <div>
            <div className='card mt-1'>
                <div className='card-body'>
                    <div className='d-flex justify-content-between fw-bold mb-2' onClick={() => setShow(!show)}>
                        <small><i className='fas fa-camera'></i> Fotograper</small>
                        <small>{valfoto != '' ? <i className='fas fa-circle-check text-success'></i> : ''} {' '} <i className={show == false ? 'fas fa-angle-right' : 'fas fa-angle-down'}></i></small>
                    </div>

                    <div className={show == false ? 'd-none' : ''}>
                        {bookfoto.status == 'book' && dataBookingFoto.id == null ? <div className='text-center alert alert-danger border-0' style={{ fontSize: '12px' }}>
                            <small>Mohon maaf layanan fotograper untuk di tanggal
                                dan jam yang anda pilih sudah digunakan oleh pengguna lain. Ubah tanggal main atau jam main untuk dapat menggunakan layanan fotograper</small>
                        </div> : <>
                            {foto.map((data, index) => {
                                return (
                                    <div key={index}>
                                        <div className='d-flex justify-content-between' key={index}>
                                            <div>
                                                <small style={{ color: "#2b2e5a" }} className='fw-bold'>{data.nama}</small>
                                                <div>
                                                    {data.harga2 == '' ? '' : <small><s>{formatrupiah(data.harga2)}</s></small>}
                                                </div>
                                                <div><span className='badge rounded-pill bg-success'>{formatrupiah(data.harga)}</span></div>
                                            </div>
                                            <div>
                                                <div class={dataBookingFoto.id == data.id ? 'form-check d-none' : 'form-check'}>
                                                    <img
                                                        src={
                                                            "https://ratumerak.id/adminmmsc/assets/berkas/" +
                                                            data.foto
                                                        }
                                                        className="img-fluid"
                                                        alt="Responsive image"
                                                        style={{ height: "40px" }}
                                                    ></img>
                                                    <input
                                                        class="form-check-input  border border-danger"
                                                        type="checkbox"
                                                        name="foto"
                                                        onChange={(e) => handlefoto(e, data.id, data.harga)}
                                                        id="foto"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {dataBookingFoto.id == data.id ? <><div className='text-danger text-center mt-2'><i className='fas fa-warning'></i> Layanan foto ini sudah anda booking <br /> <button className={dataBookingFoto.status == '1' ? 'd-none' : 'btn btn-danger btn-sm'} onClick={() => Handlehapusfoto(kode_booking, data.id)}><i className='fas fa-trash'></i> Hapus</button></div></> : <></>}
                                        <hr />

                                    </div>
                                )
                            })}
                        </>}
                    </div>
                </div>
            </div>
        </div>
    )
}
